import { Component, Input } from "@angular/core";
import { Article } from "src/app/model/order/order";

@Component({
    selector: 'app-catalogue-item',
    templateUrl: './catalogue-item.component.html',
    styleUrls: ['./catalogue-item.component.scss']
  })
  export class CatalogueItemComponent {
    @Input() item: Article;
  }